import { render, staticRenderFns } from "./RequestSender.vue?vue&type=template&id=978e3b84&scoped=true&lang=pug"
import script from "./RequestSender.vue?vue&type=script&lang=js"
export * from "./RequestSender.vue?vue&type=script&lang=js"
import style0 from "./RequestSender.vue?vue&type=style&index=0&id=978e3b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978e3b84",
  null
  
)

export default component.exports